import React from 'react';
import { Tabs } from 'antd';
import GenerateReportButton from './GenerateReportButton';
import GeneralTemplateReport from './GeneralTemplateReport';
import TopUnoptimizedTemplates from './TopUnoptimizedTemplates';
import TopUnoptimizedCategories from './TopUnoptimizedCategories';

const { TabPane } = Tabs;

export default function TemplateReport(props) {
  return (
    <div>
      <div className="flex" style={{ justifyContent: 'flex-start' }}>
        <GenerateReportButton />
      </div>
      <div style={{ marginTop: 15 }}>
        <GeneralTemplateReport />
      </div>
      <h4>Top Unoptimized Templates / Categories</h4>
      <Tabs>
        <TabPane key="templates" tab="By Templates">
          <TopUnoptimizedTemplates />
        </TabPane>
        <TabPane key="categories" tab="By Categories">
          <TopUnoptimizedCategories />
        </TabPane>
      </Tabs>
    </div>
  );
}
